import Chroma from 'chroma-js'

const minValue = 0
const maxValue = 100
// 4A0009

const colorScale = Chroma.bezier(['#B6D61B', '70B50F', '#E2430D', 'E30F04', '000'])
  .scale()
  .domain([minValue, maxValue])
  .correctLightness()

export { minValue, maxValue, colorScale }

export default colorScale
